import { CustomButton } from "@root/components/common/button/customButton";
import {
  EmailVerifyWrapper,
  EmailVerifyIconCircle,
  EmailVerifyIcon,
  EmailVerifyHeading,
  EmailVerifyText,
} from "./style";
import { Text, Flex } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const RoleChangeModal = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation("common");
  const location = useLocation();
  const companyName = location.state?.companyName;

  return (
    <Flex h={"100%"} width="100%" align="center" justify="center" bg="#F7F7FB">
      <EmailVerifyWrapper shadow={"none"}>
        <EmailVerifyIconCircle>
          <EmailVerifyIcon />
        </EmailVerifyIconCircle>

        <EmailVerifyHeading>{t("awaitingApproval.title")}</EmailVerifyHeading>

        <EmailVerifyText marginBottom={"24px"}>
          {t("awaitingApproval.subTitle")}&nbsp;
        </EmailVerifyText>
        <CustomButton
          text={t("Continue")}
          borderRadius={"8px"}
          border={"1px solid #1819B4"}
          width="fit-content"
          fontSize="14px"
          fontWeight={500}
          height={"34px"}
          onClick={onClose}
          background="#1819B4"
          _hover={{ background: "#1819B4" }}
        />
      </EmailVerifyWrapper>
    </Flex>
  );
};
